// extracted by mini-css-extract-plugin
export default {"tag":"styles_tag__XLW9i","selectableTag":"styles_selectableTag__9eE7x","removeButton":"styles_removeButton__rjctK"};